// TODO PP-16776: move LoggedInWeb/utils/ajax-client here once we complete webpack LoggedInWeb migration

export * from '../../LoggedInWeb/utils/ajax-client';
